<template>
    <div class="  con_content">
        <div class="container">
            <div class="container_top h_48">
                推荐管理
               
            </div>
           
            <div >

                
                
                <!-- table组件 -->
                <div class="my_table "  >
                    <Header class="my_title txt_l">
                        <span class="my_titleL">
                        <Icon class="fw_900 " type="ios-list" size='30'/>     
                            推荐管理 
                        </span>
                        
                        <div class="ct_rgt">   
                            <!-- <div class="sta_btn " type="primary"   @click="exportData">导出数据</div> -->   
                        </div>
                    </Header>
                    
                    <Table     border :columns="columns1" :data="data1" ref='table' >
                      
                        <!-- 待审核按钮 -->
                        <template slot-scope="{ row, index }" slot="btn" >
                       
                            <span  >
                                <Poptip trigger="hover"   content="查看">
                                    <Button class="padlr5" size="small"  @click='route="/layout/circle/content/query";txtFun(row)'  type="success"      icon="md-search"></Button>
                                </Poptip>
                                <Poptip trigger="hover"  content="取消推荐">
                                    <Button class="padlr5"  size="small" @click='route="/layout/circle/content/no_recommend";btnFun(row)'  type="error"      icon="md-close"></Button>
                                </Poptip>
                            </span>
     
                        </template>                        
                          
                    </Table>
                    <Footer>
                       <Page  :current.sync="page" :total="total" :page-size='size'    @on-change='change_page' @on-page-size-change='change_size' show-total  show-sizer />
                    </Footer>      
                </div>
            </div>
       </div>

       <!-- 查看详情-->
        <Modal
            v-model="txtM"
            title = "查看详情"
            class-name="vertical-center-modal"
            okText="关闭"
            cancelText=""
            closable
            >

            <div v-if='this_guid'>
                <Child  :child_guid='this_guid' :txtM_c='txtM' ></Child>
            </div>
            
           
            
        </Modal>
       
      



       <!-- 操作弹窗-->
        <Modal
            v-model="btnM"
            title="提示"
            class-name="vertical-center-modal"
            @on-ok="btn_ok"
            @on-cancel="btn_cancel"
            >
            <p>{{btn_content}}</p>
            
        </Modal>
      
        
  </div>
</template>

<script>
    import { mapState,mapMutations,mapGetters } from 'vuex';
    import { format } from 'path';
    import Child from '../../child_vue/report_child.vue';

    export default {
        name:'recommend',
        data () {
            return {
                txt:false,
                route: null,
                guid: null,
                titles: 3,   //视频，图文，文字，推荐
                
                
                btn_content: "确定取消推荐吗？",

                //内容
                columns1:[],   
                data1:[],
                total: null,
                page:1,
                size: 20,
                state: 0,
            

                txtM: false,
                this_guid:  null,
                content: null,
                imgM: false,
                look_img: null,

                btnM: false,
                btn_state: 0,
              
               
               
                
                
            }
        },
     
        watch:{
           
          
        },
        
        computed: {
            
       
        },
        // 子模板
        props: ['child_guid','txtM_c'],
        components: {
            Child
        },
        
        methods: {
           load(){
                let that = this;
                let url;

                url = "admin/service/admin/trend/article/recommend"; 
                that.columns1= [  
                    {title:'所属分类',key:'TopicName2',align:'center',width:'250'},
                    {title:'用户昵称',key:'name2',align:'center',minWidth: 80},
                    {title:'ID',key:'number',align:'center',minWidth: 80},
                    {title:'类型',key:'type',align:'center',minWidth: 80},
                    {title:'评论数',key:'count',align:'center',width: '90'},
                    {title:'点赞数',key:'like_num',align:'center',width: '90'}, 
                    {title:'发布时间',key:'create_time',align:'center',minWidth: 125,maxWidth:200},
                    {title:'推荐时间',key:'better_time',align:'center',minWidth: 125,maxWidth:200},
                    {title:'操作',slot:'btn',align:'center',width:130,fixed: 'right'},
                ];

                that.$myAjax.get(
                    url+'?page='+that.page+'&size='+that.size+'&state='+that.audit
                ).then(function(res){
                    let list = res.data.data.list;
                    
                    if(list){
                        
                    }else{
                        list = [];
                       
                    }
                    for(let i = 0;  i<list.length;i++){
                        list[i].name2 = list[i].surname + list[i].name;

                    }
                    that.$split(list);
                    that.$data_null.editor(list);   //没有数据的以 N/A 替代
                    
                    that.data1 = list;

                    that.total =  res.data.data.total;
                    
                })
            },
         
            change_page(index){
                this.load();
            },
            change_size(size){
                this.size = size;
                this.load();
            },

            // 操作按钮
            btnFun(row){
                let that = this;
                
                that.guid = row.guid;
                that.btnM = true;
                
                
            },
            btn_ok(){
                let that = this;
                //btn_state   0 待审核 1审核成功 2审核未通过 3屏蔽    6推荐(1)   7取消推荐(0) 8删除
               
                   
                   
                that.$myAjax.put('admin/service/admin/trend/article/better?route='+that.route,{
                
                    isBetter: 0,guid:that.guid
                }).then( res => {
                    that.load();
                })
                
                
            },
            btn_cancel(){
                this.btn_state = false;
            },
           
            selectFun(){
                this.load()
            },
            // 详细查看
            txtFun(row){
                let that = this;
                that.txtM = true;
                that.this_guid = row.guid;

            },
            
         
        },
        mounted: function(){
           let that = this;     
           that.load();
        }
    }
</script>
<style scoped>
    @import "/css/modal.css";
    #myVideo{
        width: 100% !important;
        height: 220px !important;
    }
    .con_c{
        width: 80%;
        margin-left: 10%;
        height: 300px;
        padding: 10px;
        overflow-y: auto;
        overflow-x: hidden;
        
        border: 1px solid #e8eaec;
        border-radius: 10px;
    }
    .con_txt{
        margin-bottom: 20px;
    }
    .con_img{
        width: 100%;
        position: relative;
        height: auto;
    }
    .con_img img{
        width: calc(100% - 20px);
        
    }
    .t_in{
        text-indent: 20px;
    }
   
</style>




